import { Allocation, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function removeAllocation(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Allocation>) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/allocations/${uuid}`,
        method: HttpMethods.DELETE,
      })
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { removeAllocation };
